import { render, staticRenderFns } from "./pointsDetails.vue?vue&type=template&id=ee04f946&scoped=true&"
import script from "./pointsDetails.vue?vue&type=script&lang=js&"
export * from "./pointsDetails.vue?vue&type=script&lang=js&"
import style0 from "./pointsDetails.vue?vue&type=style&index=0&id=ee04f946&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee04f946",
  null
  
)

export default component.exports